<template>
  <div class="headerForSection">
    <div>
      <div>
        <h1 class="headerForSection_wrap_content_title">
          <b-row>
            <b-col sm="3"
                   class="headerType">
              <svg class="headerForSection_icon icon--md typeIcon"
                   role="presentation">
                <use :xlink:href="'#' + getIconId(icone)" />
              </svg>
              {{ texto || title }}
            </b-col>
            <b-col v-if="type == 'O'"
                   sm="5"
                   class="headerSectionObito">
              <b-row class="resumo-show_title-label pt-2">
                Novo Registro
              </b-row>
              <b-row class="headerFor cadastroInfo">
                <span class="headerFor_text">Data de início de preenchimento</span>
                <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
              </b-row>
            </b-col>
            <b-col v-if="type == 'N'"
                   sm="5"
                   class="headerSectionNascimento">
              <b-row class="resumo-show_title-label pt-2">
                Novo Registro
              </b-row>
              <b-row class="headerFor cadastroInfo">
                <span class="headerFor_text">Data de início de preenchimento</span>
                <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
              </b-row>
            </b-col>
            <b-col v-if="type == 'NL'"
                   sm="5"
                   class="headerSectionNascimento">
              <b-row class="resumo-show_title-label pt-2">
                2ª via
              </b-row>
              <b-row class="headerFor cadastroInfo">
                <span class="headerFor_text">Data de início de preenchimento</span>
                <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
              </b-row>
            </b-col>
            <b-col v-if="type == 'C'"
                   sm="8"
                   class="headerSectionCasamento">
              <b-row class="resumo-show_title-label pt-2">
                Novo Registro
              </b-row>
              <b-row class="headerFor_casamento cadastroInfo_casamento">
                <div class="p-0 m-0"
                     :class="!propCasamento.registro.matricula ? 'col-4' : 'col-5'">
                  <span class="headerFor_text">Data de início de preenchimento</span>
                  <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
                </div>
                <div v-if="propCasamento.registro.matricula"
                     class="col-6 p-0 m-0">
                  <span class="headerFor_text">Matrícula da habilitação de casamento</span>
                  <span class="headerFor_info">
                    <router-link :to="`/habilitar-casamento/resumo/${propCasamento.habilitacao_casamento_id}`"
                                 class="link">
                      {{ propCasamento.registro.matricula | maskMatricula }}
                    </router-link>
                  </span>
                </div>
              </b-row>
            </b-col>
            <b-col v-if="type == 'CL'"
                   sm="8"
                   class="headerSectionCasamento">
              <b-row class="resumo-show_title-label pt-2">
                2ª Via
              </b-row>
              <b-row class="headerFor_casamento cadastroInfo_casamento">
                <div class="p-0 m-0"
                     :class="!propCasamento.registro.matricula ? 'col-4' : 'col-5'">
                  <span class="headerFor_text">Data de início de preenchimento</span>
                  <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
                </div>
              </b-row>
            </b-col>
            <b-col v-if="type == 'OL'"
                   sm="5"
                   class="headerSectionObito">
              <b-row class="resumo-show_title-label pt-2">
                2ª Via
              </b-row>
              <b-row class="headerFor cadastroInfo">
                <span class="headerFor_text">Data de início de preenchimento</span>
                <span class="headerFor_info"> {{ dataInicio || new Date() | date }} </span>
              </b-row>
            </b-col>
          </b-row>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
  import obitoIcone from '@/assets/icons/flower.svg?sprite'
  import casamentoIcone from '@/assets/icons/engagement.svg?sprite'
  import nascimentoIcone from '@/assets/icons/nascimento.svg?sprite'
  import livroEIcone from '@/assets/icons/book-open-variant.svg?sprite'

  export default {
    name: 'HeaderForSection',
    props: {
      icone: Number,
      data: String,
      texto: String,
      dataInicio: String,
      propCasamento: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        obitoIcone,
        livroEIcone,
        casamentoIcone,
        nascimentoIcone,
        title: '',
        type: '',
      }
    },
    methods: {
      getIconId (val) {
        switch (val) {
        case 1:
          this.title = 'Óbito'
          this.type = 'O'
          return obitoIcone.id
        case 2:
          this.title = 'Livro E'
          return livroEIcone.id
        case 3:
          this.title = 'Casamento'
          this.type = 'C'
          return casamentoIcone.id
        case 4:
          this.title = 'Nascimento'
          this.type = 'N'
          return nascimentoIcone.id
        case 5:
          this.title = 'Nascimento'
          this.type = 'NL'
          return nascimentoIcone.id
        case 6:
          this.title = 'Casamento'
          this.type = 'CL'
          return casamentoIcone.id
        case 7:
          this.title = 'Óbito'
          this.type = 'OL'
          return obitoIcone.id
        default:
          return ''
        }
      },
    },
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .headerForSection {
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    height: 98px;

    &_wrap {
      &_content {
        @include calc(width, '100% - #{pxToRem(48)}', null);

        &_title {
          font-size: pxToRem(22);
          font-weight: 500;
        }
      }
    }
  }
   .headerSectionObito{
     position: relative;
     right: 170px;
   }
  .headerSectionNascimento{
     position: relative;
     right: 110px;
   }
   .headerSectionCasamento{
     position: relative;
     right: 110px;
   }
   .headerType{
     position: relative;
     top: 25px;
   }
   .cadastroInfo{
     max-width: 13rem;
     padding-top: 7px;

     &_casamento {
      padding-top: 7px;
     }
   }



   .headerFor {
    color: white;
    font-size: pxToRem(14);
    font-weight: 500;
    max-width: 13rem;

    &_casamento {
      color: white;
      font-size: pxToRem(14);
      font-weight: 500;
    }

    &_text,
    &_info {
      display: inline-block;
      line-height: pxToRem(14);
      min-height: pxToRem(14);
      width: 100%;

    }

    &_text {
       border-bottom: 0.0625rem solid white;
       padding-bottom: 2px;
       margin-bottom: 2px;
    }

    &_info {
      word-break: break-all;

    }
  }

  .typeIcon{
    position: relative;
    bottom: 5px;
    font-size: 22px;
  }

  .link {
    color: #FFFFFF;
    fill: #FFFFFF;

    &_icon {
      width: 15px;
    }
  }

  .link:hover {
    color: #FFFFFF;
  }
</style>
